import React from 'react';
import styles from './style.module.css'
import { Column, OrderTable } from '../../components/orderTable';
import { StatusCard } from '../../components/statusCard/StatusCard';
import { CategorySelector } from '../../components/TableSelector';
import Typography from '../../components/Typography/Typography';
import { OrderList } from '../../components/OrderList';
import { dateFormatter, getDateRange } from '../../utils/formatDate';
import { truncateText } from '../../utils/truncation';

interface Order {
  id: string;
  address: string;
  item: number;
  date: string;
  price: number;
  status: React.ReactNode;
}

const BuyerOrdersPage: React.FC = () => {
  
  const columns: Column<Order>[] = [
    { title: "ORDER ID", key: "id" },
    { title: "ADDRESS", key: "address" },
    { title: "ITEM", key: "item" },
    { title: "DATA", key: "date" },
    { title: "PRICE", key: "price" },
    { title: "STATUS", key: "status" },
  ];

  const data: Order[] = [
    { id: "1023", address: truncateText("No. 5 Victoria Island", 17), item: 2, date: `${dateFormatter(new Date("2025-08-22"))}`, price: 120, status: <StatusCard title="Complete" /> },
    { id: "2049", address: truncateText("12 Lekki Phase 1", 17), item: 1, date: "2025-08-21", price: 75, status: <StatusCard title="Pending" /> },
    { id: "3781", address: truncateText("45 Allen Avenue", 17), item: 6, date: "2025-08-20", price: 300, status: <StatusCard title="Complete" /> },
    { id: "4520", address: truncateText("No. 2 Johnson Street", 17), item: 3, date: "2025-08-19", price: 150, status: <StatusCard title="Pending" /> },
    { id: "5894", address: truncateText("77 Broad Street", 17), item: 5, date: "2025-08-18", price: 200, status: <StatusCard title="Complete" /> },
    { id: "6407", address: truncateText("10 Marina Road", 17), item: 2, date: "2025-08-18", price: 90, status: <StatusCard title="Pending" /> },
    { id: "7215", address: truncateText("34 Ajah Market", 17), item: 4, date: "2025-08-17", price: 180, status: <StatusCard title="Complete" /> },
    { id: "8129", address: truncateText("16 Surulere Way", 17), item: 7, date: "2025-08-16", price: 350, status: <StatusCard title="Pending" /> },
    { id: "9350", address: truncateText("23 Yaba Tech Road", 17), item: 1, date: "2025-08-15", price: 60, status: <StatusCard title="Complete" /> },
    { id: "10245", address: truncateText("50 Ikeja GRA", 17), item: 8, date: "2025-08-15", price: 400, status: <StatusCard title="Pending" /> },
  ];

  const categories = [
    { id: "all", label: "All" },
    { id: "pending", label: "Pending" },
    { id: "completed", label: "Completed" },
    // { id: "cancelled", label: "Cancelled" },
  ];

  return (
    <div className={styles.container}>

      <div className={styles.categoryDateContainer}>

        <div className={styles.categoryContainer}>

          <CategorySelector
            categories={categories}
            defaultSelected="all"
            onSelect={(id) => console.log("Selected category:", id)}
          />

        </div>

        <div className={styles.rangeDesktop}>

          <Typography>

            {getDateRange(4)}

          </Typography>

        </div>

      </div>

      <div className={styles.rangeMobile}>

        <Typography>

          {getDateRange(4)}

        </Typography>

      </div>

      <div className={styles.tableContainer}>

        <OrderTable
          header={columns}
          data={data}
          route="/buyer-order"
        />

      </div>

      <div className={styles.moblieView}>

        {data.map((item) => (
          <OrderList
            id={item.id}
            address={item.address}
            item={item.item}
            date={item.date}
            price={item.price}
            status={item.status}
            route="/buyer-order"
          />
        ))}

      </div>

    </div>
  );
};

export default BuyerOrdersPage;
